import React from "react";
import { FinanceIcon } from "../../../assets/svg/FinanceIcon";
import { LabelText } from "../../../ui/Text";
import styled from "styled-components";
import { NavLink, useRouteMatch } from "react-router-dom";

interface IProps {
  title: string;
  label: string;
  to?: string;
  isInactive?: boolean;
  onClick?: any;
}
export const ObjectiveItem = ({
  label,
  title,
  to,
  isInactive,
  onClick,
}: IProps) => {
  const { url } = useRouteMatch();
  return (
    <ObjectiveItemContainer
      onClick={onClick}
      isInactive={!!isInactive}
      to={isInactive ? "#" : `${url}/${to}`}
    >
      <FinanceIcon />
      <ObjectiveLabelContainer>
        <LabelText>{label}</LabelText>
        <LabelText style={{ color: "#214160" }}>{title}</LabelText>
      </ObjectiveLabelContainer>
    </ObjectiveItemContainer>
  );
};

const ObjectiveItemContainer = styled(NavLink)<{ isInactive?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 8fr;
  grid-column-gap: 2em;
  height: 4em;
  align-items: center;
  text-decoration: none;
  padding: 1em 2em;
  &.active {
    background-color: ${(props) => !props.isInactive && "#ebefff"};
  }
`;

const ObjectiveLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${LabelText} {
    margin-bottom: 0.5em;
  }
`;
